export class Allergies {
    allergy: string;
    public constructor(){
        this.allergy = "";
    }
}
